"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var is_json_1 = __importDefault(require("./locales/is.json"));
// English is the default message in each of our source files, so no need for a separate en.json file
var en = {};
// If we add more than just spanish, just import the files and export it below: export default { en, es, de }
exports.default = { en: en, is: is_json_1.default };
